module.exports = __webpack_public_path__ + "static/img/YouFuBao.f6cd3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/phone/YouFuBao.png
// module id = 113L
// module chunks = 1